// extracted by mini-css-extract-plugin
module.exports = {"container":"kF","disabled":"lF","snail":"mF"};